import { ITraceable } from "./_traceable";
import { IParameter } from "./parameter";
import { ICenter } from "./center";
import { IDilutorControl } from "./dilutorControl";
import { IPowderType } from "./powderType";

enum StateOfBath
{
    Archived = 0, // Archivé
    Used = 1, // Utilisé
    Pending = 2, // En attente
}

enum CompliantOfBath
{
    Created = 0, // Bain créé
    Compliant = 1, // Conforme
    NonCompliant = 2, // Non Conforme,
    NonCompliantValidated = 3, // Non Conforme mais validé par l'utilisateur
}

interface IDilutorBath extends ITraceable {
    // ID properties for hydration
    centerId: number;
    powderTypeId: number;

    // Navigation properties (hydrated by frontend)
    center: ICenter;
    powderType: IPowderType;

    // Child entities (included in API response)
    controls : Array<IDilutorControl>;

    name: string;
    powderLotNumber: string;
    powderExpiryDate: Date;
    bathAvailableVolume: number;
    bathRemainingVolume: number;
    //isCompliant: boolean;
    //isArchived: boolean;
    state: StateOfBath;
    compliant: CompliantOfBath;
    comment?: string;
    haveAntibiotic: boolean;
    antibioticComment?: string;
    dilutorBathAddingDate?: Date;
}

export type { IDilutorBath }
export { StateOfBath, CompliantOfBath }